import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'language-settings.generic-panel.flaggable-textfield.title',
		defaultMessage: 'Confirm Translation',
		description: 'Title for link button for outdated translations',
	},
	fieldPlaceholder: {
		id: 'language-settings.generic-panel.flaggable-textfield.field-placeholder',
		defaultMessage: 'Enter a translation...',
		description: 'Placeholder for missing translations field',
	},
});
